<template>
  <div>
    <div class="subscriber">
      <div class="subscriber-profile-info">
        <div class="subscriber-profile-info-alpha">
          <div class="subscriber-profile-info-alpha-profileImage" style="pointer-events: none;">
            <img
              class="subscriber-profile-info-alpha-profileImage-image"
              v-if="subscriberProfileDetails ? subscriberProfileDetails.picture : subscriberDetails ? subscriberDetails.picture : null"
              :src="subscriberProfileDetails ? subscriberProfileDetails.picture : subscriberDetails ? subscriberDetails.picture : null"
              alt
            />
            <!-- <img class="subscriber-profile-info-alpha-profileImage-image" v-else :src="displayPic" alt /> -->
            <ProfilePlaceHolder :width="'100%'" :height="'100%'" :color="'red'" class="subscriber-profile-info-alpha-profileImage-image" v-else></ProfilePlaceHolder>
          </div>
          <p class="subscriber-profile-info-alpha-subscribername">
          
            {{ getSubscriberProfileName }}
            <sup v-if="subscriberid === profileid" class="adminTag">
              <!-- <img src="@/assets/icons/Admin.svg" alt /> -->
              ADMIN
            </sup>
          </p>
          <p v-if="subscriberDetails.email" class="subscriber-profile-info-alpha-subscriberemail">
            {{ subscriberDetails.email }}
          </p>

          <br v-if="subscriberDetails.mobileno" />

          <p v-if="subscriberDetails.mobileno" class="subscriber-profile-info-alpha-subscriberemail">
              {{ subscriberDetails.mobileno }} 
          </p>
        </div>

        <div class="subscriber-profile-info-beta">
          <div class="subscriber-profile-info-beta-common location">
            <!-- <img src="@/assets/icons/Location.svg" alt /> -->
            <locationIcon></locationIcon>
            <p class="subscriber-profile-info-beta-common-info">
              {{ $t(subscriberDetails.subscribercountry) }}
            </p>
          </div>

          <div class="subscriber-profile-info-beta-common gender" v-if="getProfileGender">
            <!-- <img src="@/assets/icons/Name.svg" alt /> -->
            <profilegendericon></profilegendericon>
            <p class="subscriber-profile-info-beta-common-info">
              {{ $t(getProfileGender) }}
            </p>
          </div>

          <div class="subscriber-profile-info-beta-common dob" v-if="subscriberAgeRange">
            <subscriberAgesvg></subscriberAgesvg>
            <!-- <img src="@/assets/icons/Calender-1.svg" alt /> -->
            <!-- <p class="subscriber-profile-info-beta-common-info">Age</p> -->
            <!-- <p
            class="subscriber-profile-info-beta-common-info"
          >{{ displayDateFormat(subscriberDetails.dob) }}</p>-->
            <p dir="ltr" class="subscriber-profile-info-beta-common-info no-padding">
              <span>{{ subscriberAgeValue }}</span>
              {{ $t("Years") }}
            </p>
          </div>
        </div>
        <div class="subscriber-profile-info-mutable" v-if="appConfig.featureEnabled.isChangePasswordFlag || appConfig.featureEnabled.isEditProfileFlag">
          <p class="popup-methods" @click="editSubscriber('Update')" v-if="appConfig.featureEnabled.isEditProfileFlag">
            {{ $t("edit profile") }}
          </p>
          <p v-if="appConfig.featureEnabled.isChangePasswordFlag && showChangePasswordButton" class="popup-methods" @click="toggleChangePassword(true)">
            {{ $t("change password") }}
          </p>
        </div>
      </div>

      <!-- <div class="subscriber-related" v-if="!providerName === 'Noor Play'">
        <div class="subscriber-related-placeholder" v-if="!isSubProfiles">
          <div class="subscriber-related-placeholder-card" v-for="(item, index) in 2" :key="index">
            <div class="subscriber-related-placeholder-card-icon loading"></div>
            <div class="subscriber-related-placeholder-card-info">
              <p class="subscriber-related-placeholder-card-info-title loading"></p>
              <p class="subscriber-related-placeholder-card-info-type loading"></p>
            </div>
          </div>
        </div>
        <div class="subscriber-related-addprofile" v-if="isSubProfiles && subProfiles.length === 0">
          <p class="subscriber-related-addprofile-title">
            {{ $t("wish to create a subprofile") }}
          </p>
          <button
            class="button-primary subscriber-related-addprofile-btn"
            :class="[providerUniqueId === 'z01x1wPo' ? 'primary-nammaflix-button' : 'primary-net5-button']"
            @click="toggleProfilePopup(true, 'Create')"
          >
            + {{ $t("add profile") }}
          </button>
        </div>
        <div v-if="isSubProfiles && subProfiles.length > 0">
          <div class="subscriber-related-header">
            <p class="subscriber-related-header-title">
              {{ $t("other profiles") }}
            </p>
            <p class="subscriber-related-header-title cursor" @click="toggleProfilePopup(true, 'Create')">
              {{ $t("add profile") }} +
            </p>
          </div>

          <div class="subscriber-related-profiles">
            <div class="subscriber-related-profiles-list" v-for="(profile, index) in subProfiles" :key="index">
              <div class="subscriber-related-profiles-list-profileIcon">
                <img v-if="profile.picture" class="sub-imgs" :src="profile.picture" alt />
                <img v-else class="sub-imgs" :src="displayPic" alt />
              </div>
              <div class="subscriber-related-profiles-list-profileInfo">
                <div class="subscriber-related-profiles-list-profileInfo-list">
                  <div class="subscriber-related-profiles-list-profileInfo-list-container">
                    <p
                      class="subscriber-related-profiles-list-profileInfo-list-container-fullname"
                      v-if="profile.profilename.length <= 8"
                    >
                      {{ profile.profilename }}
                    </p>
                    <p
                      class="subscriber-related-profiles-list-profileInfo-list-container-fullname"
                      v-if="profile.profilename.length > 8"
                    >
                      {{ profile.profilename.substring(0, 8) + "..." }}
                    </p>
                    <p
                    class="subscriber-related-profiles-list-profileInfo-container-email"
                  >{{ profile.gender }}</p>
                  </div>
                  <div class="subscriber-related-profiles-list-profileInfo-actions action-btns">
                    <img :src="editIcon" @click="editProfile(profile, 'Update')" alt />
                    <img :src="deleteIcon" @click="deleteProfile(profile)" alt />
                  </div>
                </div>
                <button
                  class="button-primary subscriber-related-profiles-list-switch enable-switch"
                  :class="[providerUniqueId === 'z01x1wPo' ? 'primary-nammaflix-button' : 'primary-net5-button']"
                  @click="switchProfile(profile)"
                >
                  {{ $t("switch profile") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Change Profile and Edit profile Popup -->
      <transition>
        <div>
          <ChangePassword v-if="showChangePassword" :closePopup="() => toggleChangePassword(false)"></ChangePassword>
          <profilePopup
            v-if="showProfilePopup"
            :popupType="popupType"
            :detail="profileDetail ? profileDetail : {}"
            @refreshList="getUserInfo"
            :closePopup="() => toggleProfilePopup(false)"
          ></profilePopup>
          <confirmation
            v-if="showConfirmation"
            :deleteInfo="deleteInfo"
            @deleteConfirm="getUserInfo"
            @refreshProfilesList="getUserInfo"
            :closePopup="() => toggleConfirmation(false)"
          ></confirmation>
        </div>
      </transition>
    </div>

    <!-- The Manage Profile Container -->
    <div v-if="subscriberid === profileid && appConfig.featureEnabled.isMultipleProfileEnabled" :class="[
          localDisplayLang === 'ara' ? 'manageProfileContainerArabic' : 'manageProfileContainer',
        ]" 
    >
      <div class="manageProfiles">
        <div class="align-space-between" >
          <p class="manageProfilesText">{{$t("manage profiles")}}</p>
          <div
              class="icon-container"
              @click="addProfile"
              v-if="showAddProfileButton && appConfig.featureEnabled.isEditProfileFlag"
              >
            <profileaddicon></profileaddicon>
            
              </div>
        </div>
        <div v-for="userProfile in profilesList" :key="userProfile.profileid" class="profiles">
          <div class="profileDetails" style="pointer-events: none;" >
            <!-- <img v-if="!userProfile.picture" src="@/assets/icons/Generic.png" alt="" class="profileImage" /> -->
            <ProfilePlaceHolder :width="40" :height="40" :color="userProfile.color" v-if="!userProfile.picture" class="profileImage"></ProfilePlaceHolder>
            <img v-if="userProfile.picture" :src="userProfile.picture" alt="" class="profileImage" />
            <div>
              <p style="height:16px" class="profileName">{{ userProfile.profilename }}</p>
              <p v-if="subscriberid === userProfile.profileid" class="profileBadge">{{ $t("admin") }}</p>
							<p v-if="userProfile.kidsmode === 'YES'" class="profileBadge">{{ $t("kids") }}</p>
							<!-- <p v-if="subscriberid === userProfile.profileid" class="profileBadge">{{ $t("admin") }}</p> -->
            </div>
          </div>
          <!-- <div>
            <div class="icon-parent">
              <div
              class="icon-container"
             @click="editProfile(userProfile)"
             v-if="appConfig.featureEnabled.isEditProfileFlag"
              >
              <profileediticon></profileediticon>
              </div>
              <div
              class="icon-container"
              v-if="subscriberid !== userProfile.profileid && appConfig.featureEnabled.isEditProfileFlag" @click="deleteProfile(userProfile)"
              >
              <profiledeleteicon></profiledeleteicon>
              </div>
            </div>
         
          </div> -->
          <div class="icon-parent">
        <div
          class="icon-container"
          @click="editProfile(userProfile)"
          v-if="subscriberid === userProfile.profileid && appConfig.featureEnabled.isEditProfileFlag"
        >
          <profileediticon></profileediticon>
        </div>
        <div
          class="icon-container"
          v-if="subscriberid !== userProfile.profileid && appConfig.featureEnabled.isEditProfileFlag"
          @click="deleteProfile(userProfile)"
        >
          <profiledeleteicon></profiledeleteicon>
        </div>
      </div>
        </div>
        <div class="deleteMyAccount" v-if="appConfig.featureEnabled.isDelteAccountFlag">
        <p @click="deleteSubscriber">{{$t("Delete Account?")}}</p>
      </div>
      </div>
    </div>
    <!-- The Manage Profile Container -->
    <!-- <div :class="[ localDisplayLang === 'ara' ? 'manageProfileContainerArabic' : 'manageProfileContainer', ]">
      <div class="manageProfiles">
        <div class="align-space-between" >
          <p class="manageProfilesText">
            {{$t(this.defaultThemeColor == 'theme-light' ? 'Light Theme' : 'Dark Theme' )}}</p>
            <label class="toggle">
              <input type="checkbox" @change="toggleTheme" />
              <span class="slider round"></span>
            </label>
        </div>
      </div>
    </div> -->
    <DeleteAccount 
    v-if="showDeleteModal"
     @closePopup="closeDeleteModal"
     @hideCloseConfirmation="onCloseDeleteConfirmation"
    />
  </div>
</template>
<script>
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import { mapActions, mapGetters } from "vuex";
import { _providerId, _projectName } from "@/provider-config.js";
import { setUserPropertiesFunc } from '@/utilities';

export default {
  data() {
    return {
      subscriberDetails: null,
      showChangePassword: false,
      subProfiles: [],
      displayPic: require("@/assets/icons/Generic.png"),
      editIcon: require("@/assets/icons/Edit.svg"),
      deleteIcon: require("@/assets/icons/Trash.svg"),
      profileSectionLoader: false,
      isSubProfiles: false,
      showProfilePopup: false,
      showConfirmation: false,
      popupType: null,
      profile: null,
      subscriber: null,
      profileDetail: null,
      deleteInfo: null,
      subscriberAgeRange: null,
      providerUniqueId: _providerId,
      providerName: _projectName,
      localDisplayLang:"",
      profilesList: null,
      subscriberProfileDetails: null,
      loginType: null,
      subscriberAgeValue: null,
      subscriptionDetails: null,
      noOfUserProfilesLimit: 4,
      defaultThemeColor: '',
      showDeleteModal:false
    };
  },

  computed: {
    ...mapGetters(["appConfig", "subscriberid", "profileid"]),

    showChangePasswordButton() {
      if(this.profileid === this.subscriberid && this.loginType !== "Google" && this.loginType !== 'FB') {
        return true;
      }
    },



    showAddProfileButton() {
      if (
        this.subscriberid === this.profileid &&
        this.profilesList &&
        this.profilesList.length < this.noOfUserProfilesLimit
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSubscriberProfileName() {

      if (this.subscriberProfileDetails && this.subscriberProfileDetails.profilename && this.subscriberProfileDetails.profilename.length > 15) {
        return `${this.subscriberProfileDetails.profilename.substring(0, 15)}...`;
      } else if (this.subscriberProfileDetails && this.subscriberProfileDetails.profilename) {
        return this.subscriberProfileDetails.profilename;
      } else if (this.subscriberDetails.profilename && this.subscriberDetails.profilename.length > 15) {
        return `${this.subscriberDetails.profilename.substring(0, 15)}...`;
      } else {
        return this.subscriberDetails.profilename;
      }
    },

    getProfileGender () {

      if (this.subscriberProfileDetails && this.subscriberProfileDetails.gender) {
        return this.subscriberProfileDetails.gender;
      } 
      
      else if(this.subscriberDetails && this.subscriberDetails.gender) {
        return this.subscriberDetails.gender;
      } 
    }
  },

  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.getUserInfo();

    this.getCurrentProfileDetails();
    // this.toggleTheme();


  },

  mounted() {

    this.defaultThemeColor = localStorage.getItem('theme') ? localStorage.getItem('theme') : 'theme-dark'
    window.addEventListener("localstorage-updated", (event) => {
      this.subscriberDetails = JSON.parse(event.detail.storage).data;
      let subscriberAge = parseInt(this.subscriberDetails.age);

      this.getCurrentProfileDetails();
      // this.toggleTheme();

      this.getSubscriberAgeRange(subscriberAge);
    });
  },
  methods: {
    ...mapActions(["listProfiles", "deleteProfile"]),


    deleteSubscriber(){
     this.showDeleteModal=true;    
     document.body.style.overflow = "hidden";    
    },
    closeDeleteModal() {
      this.showDeleteModal = false; 
      document.body.style.overflow = "auto";  
    },


   toggleTheme(){
    
    this.defaultThemeColor = this.defaultThemeColor == 'theme-dark' ? 'theme-light' : 'theme-dark';
    localStorage.setItem('theme', this.defaultThemeColor);
    eventBus.$emit("theme-change", this.defaultThemeColor)
    document.documentElement.className = this.defaultThemeColor;

},

    getUserInfo() {
      this.isSubProfiles = false;
      if (localStorage.getItem("subscriberDetails")) {
        this.subscriberDetails = JSON.parse(localStorage.getItem("subscriberDetails")).data;
      }

      this.loginType = localStorage.getItem("login-payload") ? localStorage.getItem("login-payload") : ""

      if (localStorage.getItem("subscriptionDetails")) {
        this.subscriptionDetails = JSON.parse(localStorage.getItem("subscriptionDetails"));
      }

      // if(this.subscriberid === this.profileid) {
        this.listUserProfiles();
      // }

      this.getCurrentProfileDetails();

      setUserPropertiesFunc(this.subscriberDetails, this.subscriptionDetails);
    },

    getCurrentProfileDetails() {
      this.subscriberProfileDetails = localStorage.getItem("subscriberProfileDetails")
        ? JSON.parse(localStorage.getItem("subscriberProfileDetails"))
        : null;

      const ageOfSubscriber = this.subscriberProfileDetails ? this.subscriberProfileDetails.age : "";
      if(ageOfSubscriber) {
        this.getSubscriberAgeRange(parseInt(ageOfSubscriber));
        this.subscriberAgeValue = parseInt(ageOfSubscriber);
      }
    },

    listUserProfiles() {
  this.listProfiles()
    .then((response) => {
      if (response.data) {
        let lists = response.data.data;
        let adminIndex = lists.findIndex(profile => profile.profileid === this.profileid);

        if (adminIndex !== -1) {
          let adminProfile = lists.splice(adminIndex, 1)[0];
          this.profilesList = [adminProfile, ...lists];
          localStorage.setItem("profile-list", JSON.stringify(this.profilesList));
          this.subscriberProfileDetails = adminProfile;
          this.subscriberAgeValue = parseInt(this.subscriberProfileDetails.age);
          localStorage.setItem("subscriberProfileDetails", JSON.stringify(adminProfile));
        } else {
          this.profilesList = lists;
          localStorage.setItem("profile-list", JSON.stringify(this.profilesList));
        }
        let colors = ['red', 'green', 'blue', 'yellow', 'skyblue', 'pink', 'purple', 'lightred'];
        this.profilesList = this.profilesList.map((single, i) => {
          if(!single.picture){
            single.color = colors[i];
          }
          return single;
        });

        this.isLoading = false;
      }
    })
    .catch((err) => {
      
      this.isLoading = false;
    });
},


    getSubscriberAgeRange(data) {
      switch (true) {
        case data < 13:
          this.subscriberAgeRange = "<13";
          
          break;
        case data < 18:
          this.subscriberAgeRange = "13-17";
          
          break;
        case data < 31:
          this.subscriberAgeRange = "18-30";
          
          break;
        case data < 45:
          this.subscriberAgeRange = "31-45";
          
          break;
        case data > 45:
          this.subscriberAgeRange = "45+";
          
          break;
        default:
          break;
      }
    },

    switchProfile(profile) {
      
      if (profile.profilepin === "ENABLED") {
        eventBus.$emit("switchProfile", profile);
      } else {
        eventBus.$emit("enableOverlayLoader", true);

        let payload = {
          profileid: profile.profileid,
        };
        eventBus.$emit("switch-profile", payload);
      }
    },

    editSubscriber(value) {
      this.profileDetail = this.subscriberProfileDetails ? this.subscriberProfileDetails : this.subscriberDetails;
      this.toggleProfilePopup(true, value);
    },

    editProfile(data) {
      this.profileDetail = data;

      this.toggleProfilePopup(true, 'Update');
    },

    deleteProfile(data) {
      this.toggleConfirmation(true);
      this.deleteInfo = data;
    },

    addProfile(){
      let currentLanguage = this.getCurrentLanguageUrlBase();
      this.$router.push({name: "addProfileCheck", params: { lang: currentLanguage}})
    },

    toggleChangePassword(state) {
      let idToken = localStorage.getItem("idToken");
      if(idToken) {
        window.open(`${this.appConfig.urls.externalbased.changePasswordUrl}data=${idToken}`, '_blank');
      }
      // this.showChangePassword = state;
    },

    toggleConfirmation(state) {
      this.showConfirmation = state;
    },

    toggleProfilePopup(state, value) {
      if (!state) {
        this.profileDetail = {};
      }
      this.popupType = value;
      this.showProfilePopup = state;
    },
  },
  components: {
    ChangePassword: () =>
      import(/* webpackChunkName: "header" */ "@/components/Popups/ProfilePopups/ChangePassword.vue"),
    profilePopup: () => import(/* webpackChunkName: "header" */ "@/components/Popups/ProfilePopups/profilePopup.vue"),
    confirmation: () => import(/* webpackChunkName: "confirmation" */ "@/components/Popups/confirmation.vue"),
    locationIcon: () => import(/* webpackChunkName: "locationIcon" */ "../../SvgImages/LocationSvg.vue"),
    subscriberAgesvg: () => import(/* webpackChunkName: "subscriberage" */ "@/components/SvgImages/calenderSvg.vue"),
    profilegendericon: () => import(/* webpackChunkName: "profilegendericon" */ "@/components/SvgImages/ProfileGenderSvg.vue"),
    profileaddicon: () => import(/* webpackChunkName: "addicon" */ "../../SvgImages/addIconsvg.vue"),
    profileediticon: () => import(/* webpackChunkName: "editicon" */ "../../SvgImages/editIconsvg.vue"),
    profiledeleteicon: () => import(/* webpackChunkName: "deleteicon" */ "../../SvgImages/deleteIconsvg.vue"),
    DeleteAccount: () => import(/* webpackChunkName: "confirmdelete" */ "@/components/Profile/Subscriber/DeleteAccount.vue"),
    ProfilePlaceHolder: () => import(/* webpackChunkName: "profilePlaceHolder" */ "@/components/SvgImages/Profilesvg.vue"),
     },
  mixins: [Utility, googleAnalytics],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
.subscriber {
  background-color: $clr-sbscrberpg-bg;
  font-family: $font-regular;
  border-radius: 1rem;
  // max-height: 100vh;
  &-profile-info {
    padding: 0.9rem 1.8rem;
    &-alpha {
      &-profileImage {
        margin-bottom: 0.6rem;
        width: 90px;
        &-image {
          width: 80%;
          height: 70px;
          border-radius: 50%;
        }
      }
      &-subscribername {
        color: $clr-sbscbername;
        font-weight: 600;
        line-height: 25px;
        margin-bottom: 0.3rem;
      }
      &-subscriberemail {
        color: $clr-sbsciberemail-txt;
        font-size: 0.9rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        width: 200px;
        }
    }
    &-beta {
      color: $clr-sbscber-countrycode-txt;
      opacity: 0.5;
      line-height: 30px;
      margin: 1.2rem 0rem;
      &-common {
        display: flex;
        img {
          margin-top: 0.5rem;
          margin-right: 8px;
          width: 15px;
          height: 15px;
        }
        &-info {
          font-size: 0.8rem;
          padding-right: 8px;
        }
        // .no-padding {
        //   padding-left: 0%;
        // }
      }
    }
    &-mutable {
      display: flex;
      justify-content: space-between;
      font-size: 1rem;
      color: $clr-sbscriber-edit-changepaswrd-txt;
      font-weight: bold;
      cursor: pointer;
      margin:10px 0px;
      .popup-methods {
        opacity: 1;
        font-size: 0.9rem;
        &:hover {
          color: $clr-sbscriber-edit-changepaswrd-hover-txt;
          opacity: 1;
        }
      }
    }
  }
  &-related {
    padding: 1.2rem 1.8rem;
    background-color: $clr-dark-gd5;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    &-placeholder {
      &-card {
        display: flex;
        align-items: center;
        background-color: $clr-dark-gd4;
        border-radius: 10px;
        margin: 0.5rem 0;
        padding: 0.5rem;
        &-icon {
          width: 20%;
          height: 40px;
          border-radius: 50%;
          background-color: #0d0d0d;
          overflow: hidden;
          margin-right: 10px;
        }
        &-info {
          &-title {
            height: 10px;
            width: 85px;
            background-color: #0d0d0d;
            margin-bottom: 5px;
            overflow: hidden;
          }
          &-type {
            height: 10px;
            width: 40px;
            background-color: #0d0d0d;
            overflow: hidden;
          }
        }
      }
    }
    &-addprofile {
      &-title {
        font-size: 1rem;
        color: #efeff4;
        font-weight: bold;
        opacity: 0.5;
        font-family: $font-regular;
      }
      &-btn {
        width: 50%;
        margin: 20px 0;
        padding: 0.4rem;
        font-size: 0.7rem;
      }
    }
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0.5rem;
      margin-bottom: 1rem;
      border-bottom: 1px solid $clr-dark-gd11;
      &-title {
        font-size: 0.7rem;
        color: $clr-light-gd3;
        font-weight: bold;
        opacity: 0.5;
        line-height: 30px;
        &:last-child {
          &:hover {
            color: $btn-clr;
            // color: $clr-light-gd2; // for nammaflix
            opacity: 1;
          }
        }
      }
      .cursor {
        cursor: pointer;
      }
    }
    &-profiles {
      &-list {
        display: flex;
        align-items: center;
        line-height: 15px;
        background-color: $clr-dark-gd4;
        border-radius: 10px;
        margin: 0.5rem;
        padding: 1rem;
        &-switch {
          display: none;
          padding: 0.1rem 0.5rem;
          font-size: 0.5rem;
          margin-top: 5px;
          width: 60%;
        }
        &:hover {
          background-color: $clr-dark-gd11;
          .action-btns {
            display: block;
          }
          .enable-switch {
            display: block;
          }
        }
        &-profileIcon {
          width: 45px;
          .sub-imgs {
            width: 100%;
            height: 38px;
            border-radius: 50%;
          }
        }
        &-profileInfo {
          width: 100%;
          padding-left: 0.7rem;
          &-list {
            display: flex;
            justify-content: space-between;
            width: 100%;
            &-container {
              &-fullname {
                font-size: 0.8rem;
                color: $clr-light-gd3;
                font-weight: bold;
              }
              &-email {
                font-size: 0.6rem;
                color: $clr-light-gd3;
                font-weight: bold;
                opacity: 0.5;
              }
            }
          }
          .action-btns {
            display: none;
          }
          &-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            img {
              width: 27px;
              height: 15px;
              cursor: pointer;
              // display: none;
            }
          }
        }
      }
    }
  }
}
.deleteMyAccount{
  text-align: center;
  cursor: pointer;
  color: $clr-input-textbox-text;
}
.manageProfileContainer {
  margin: 1rem 0;
  height: fit-content;
  border-radius: 1rem;
  padding: 1rem;
  background-color:$clr-manageprofile-bg;
  .manageProfiles {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .manageProfilesText {
      color: $clr-managePrfile-txt;
      font-family: $font-regular;
      font-size: 0.8rem;
      letter-spacing: 0;
      line-height: 12px;
      font-weight: 600;
      padding: 1rem;
    }

    .profiles {
      margin: 0.75rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem;
      .profileDetails {
        display: flex;
        .profileImage {
          width: 40px;
          height: 40px;
          border-radius: 0.3rem;
        }
        .profileName {
          margin: 0.25rem;
          color: $clr-profilebadge-txt;
          margin-left: 1.5rem;
          font-family: $font-regular;
          font-size: 0.8rem;
          letter-spacing: 0;
          line-height: 12px;
          font-weight: 600;
          white-space: nowrap; 
          width: 95px; 
          overflow: hidden;
          text-overflow: ellipsis; 
  
           }

        .profileBadge {

          margin-top: 0.8rem;
          color: $clr-profilebadge-txt;
          margin-left: 1.5rem;
          font-family: $font-regular;
          letter-spacing: 0;
          line-height: 12px;
          font-weight:300;
          font-size: 0.75rem;

        }
      }

      .editProfile {
        margin-bottom: 1.2rem;
        color: $clr-profilename-delte-txt;
        margin-left: 1.5rem;
        font-family: $font-regular;
        font-size: 0.8rem;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
}

.manageProfileContainerArabic {
  margin: 1rem 0;
  height: fit-content;
  border-radius: 1rem;
  padding: 1rem;
  // background-color: #212121;
  .manageProfiles {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .manageProfilesText {
      color:$clr-managePrfile-txt;
      font-family: $font-regular;
      font-size: 1rem;
      letter-spacing: 0;
      line-height: 12px;
      font-weight: 600;
      padding: 1rem;
    }

    .profiles {
      margin: 0.75rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem;
      .profileDetails {
        display: flex;
        .profileImage {
          width: 40px;
          height: 40px;
					border-radius: 50%;
        }
        .profileName {
          margin: 0.25rem;
          color: $clr-dark-gd10;
          margin-right: 1.5rem;
          font-family: $font-regular;
          font-size: 0.8rem;
          letter-spacing: 0;
          line-height: 12px;
          font-weight: 600;
        }

        .profileBadge {

          margin-top: 0.8rem;
          color: $clr-dark-gd10;
          margin-right: 1.5rem;
          font-family: $font-regular;
          letter-spacing: 0;
          line-height: 12px;
          font-weight:300;
          font-size: 0.75rem;

        }
      }

      .editProfile {
        margin-bottom: 1.2rem;
        color: $clr-dark-gd10;
        margin-right: 1.5rem;
        font-family: $font-regular;
        font-size: 0.8rem;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .profileName {
      overflow: visible !important;
        }
   .subscriber-profile-info-alpha-subscriberemail{
      overflow: visible !important;
   }
           
  .subscriber {
    margin-bottom: 20px;
    &-related {
      &-profiles {
        &-list {
          &-switch {
            display: block;
            padding: 0.2rem;
            font-size: 10px;
          }
          &-profileIcon {
            width: 60px;
            .sub-imgs {
              height: 60px;
            }
          }
          &-profileInfo {
            &-list {
              &-container {
                &-fullname {
                  font-size: 1rem;
                }
              }
            }
          }
        }
        .action-btns {
          display: block;
        }
        &-actions {
          img {
            width: 15px;
            height: 15px;
            cursor: pointer;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.toggle input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Optional CSS to style the label text */
.toggle .label {
  position: absolute;
  top: 10px;
  left: 70px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .subscriber {
    margin-bottom: 20px;
  }
    .profileName {
          overflow: visible !important;
        }
    .subscriber-profile-info-alpha-subscriberemail{
      overflow: visible !important;
   }
}

.icon-parent{
  display: flex;
  gap: 5px;
}

.icon-container{
  width: 24px;
  height: 24px;
  display: flex;
  border-radius: 100px;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease-in;
  cursor: pointer;
  img {
    max-width: 16px !important;
    max-height: 16px !important;
    height: 12px;
    width: 12px;
  }
}

// .icon-container:hover{
//   background-color: $primary-btn-color;
// }

.align-space-between{
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.toggle input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #000000;
}

input:focus + .slider {
  box-shadow: 0 0 1px #000000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Optional CSS to style the label text */
.toggle .label {
  position: absolute;
  top: 10px;
  left: 70px;
}

</style>
